export const GET_STATISTIC_GAME = "GET_STATISTIC_GAME";
export const TOTAL_PAGES_STATISTIC_GAME = "TOTAL_PAGES_STATISTIC_GAME";
export const PAGINATION_PARAMS_STATISTIC_GAME = "PAGINATION_PARAMS_STATISTIC_GAME";
export const COUNT_STATISTIC_GAME = "COUNT_STATISTIC_GAME";
